import {defineMessages, FormattedMessage} from 'react-intl';

import {Link, view} from '@sail/ui';

const PRIVACY_POLICY_LINK = 'https://www.stripe.com/privacy';

const READ_MORE_LINK =
  'https://stripe.com/legal/privacy-center#does-stripe-record-calls';

const messages = defineMessages({
  description: {
    id: 'conversations_assistant.requestACallTopBar.description',
    description: 'Details and disclaimers related to call',
    defaultMessage:
      'This call may be recorded and monitored for quality and training purposes. The recording will be processed in accordance with our {privacyPolicyLink}. {readMoreLink}.',
  },
  privacyPolicyLink: {
    id: 'conversations_assistant.requestACallTopBar.privacyPolicyLink',
    description: 'Text for privacy policy link in description',
    defaultMessage: 'Privacy Policy',
  },
  readMoreLink: {
    id: 'conversations_assistant.requestACallTopBar.readMoreLink',
    description: 'Text for read more link in description',
    defaultMessage: 'Read more',
  },
});

export function Description() {
  return (
    <view.div css={{font: 'label.small', marginTop: 'small'}}>
      <FormattedMessage
        {...messages.description}
        values={{
          privacyPolicyLink: (
            <Link
              type="secondary"
              href={PRIVACY_POLICY_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.privacyPolicyLink} />
            </Link>
          ),
          readMoreLink: (
            <Link
              type="secondary"
              href={READ_MORE_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.readMoreLink} />
            </Link>
          ),
        }}
      />
    </view.div>
  );
}
